export function hasValue(value) {
  return typeof value !== "undefined" && value !== null;
}
